export const CACHE_NanPanelOpenStatus = 'NanPanelOpenStatus'

export const LOADING_STATE_NOT_LOADED = 'empty'
export const LOADING_STATE_LOADING = 'loading'
export const LOADING_STATE_LOADED = 'loaded'
export const LOADING_STATE_ERROR = 'error'
